// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"86":"dist/admin","367":"dist/app"}[chunkId] + ".css";
};